import React from "react";
import { ThemeProvider } from "styled-components";
import {
    StyledHeader,
    StyledSubTitle,
    StyledTitle,
} from "../../styles/MainStyles";
import HelpUpload from "./HelpUpload";
import HelpList from "./HelpList";
import { HelpProvider } from "../../context/HelpContext";

const Help: React.FC = () => {
    return (
        <HelpProvider>
            <ThemeProvider theme={{}}>
                <StyledHeader>
                    <StyledTitle>Help</StyledTitle>
                    <StyledSubTitle>
                        Aqui você pode realizar o upload dos arquivos de HELP do
                        sistema
                    </StyledSubTitle>
                </StyledHeader>
                <HelpUpload />
                <HelpList />
            </ThemeProvider>
        </HelpProvider>
    );
};

export default Help;
